import { createReducer } from '@reduxjs/toolkit';
import { headerActions } from 'features/header/redux/header.action';
import { PartnerHeaderFeature } from 'features/header/ts-types';

export const initialState = {
  listHeaderFeatures: [] as PartnerHeaderFeature[],
  loadingStatus: false as boolean,
  error: [] as string[],
} as const;

const headerReducer = createReducer(initialState, (builder) => {
  builder.addCase(headerActions.getPartnerHeaderFeaturesRequest, (state) => {
    return {
      ...state,
      loadingStatus: true,
      listHeaderFeatures: [],
    };
  });
  builder.addCase(
    headerActions.getPartnerHeaderFeaturesSuccess,
    (state, action) => {
      return {
        ...state,
        loadingStatus: false,
        listHeaderFeatures: action.payload.features,
      };
    }
  );
  builder.addCase(
    headerActions.getPartnerHeaderFeaturesFailure,
    (state, action) => {
      return {
        ...state,
        loadingStatus: false,
        error: action.payload,
      };
    }
  );
});

export default headerReducer;
